import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { carouselEnum } from '@app/components/carousel/iCarousel';
import { CacheObjectService, DeviceService, EventTrackerService } from '@app/core';
import { AppParametersService } from '@app/core/token/app-parameters.service';
import { TokenService } from '@app/core/token/token.service';
import { CheckHtml5Service } from '@app/helper/check-html5.service';
import { ScrollToLastPosition } from '@app/helper/scroll-to-last-position';
import { ProductTypeEnum } from '@app/interfaces/iBook';
import { iGenre } from '@app/interfaces/IGenre';
import { IndicatorService } from '@app/shared';
import { environment } from '@env/environment';
import { filter, map } from 'rxjs/operators';

import { CLPService } from '../clp.service';

@Component({
  selector: "navaar-plp",
  templateUrl: "./plp.component.html",
  styleUrls: ["./plp.component.scss"],
})
export class PLPComponent extends ScrollToLastPosition implements OnInit {
  public carouselType: typeof carouselEnum = carouselEnum;
  public items: Array<iGenre> = [];
  public subgenres: Array<any> = [];

  public title: string;
  public identifier: number;
  public showMore: boolean = false;
  public showOldVersion: boolean = false;
  public contentType: ProductTypeEnum;

  public readonly BASE_HREF_IMAGE = environment.imageUrl;
  constructor(

    private readonly parametersService: AppParametersService,
    private readonly checkHtml5Service: CheckHtml5Service,
    private readonly activatedRoute: ActivatedRoute,
    private readonly chkd: ChangeDetectorRef,
    private readonly clpService: CLPService,
    public readonly device: DeviceService,
    private readonly cache: CacheObjectService<any>,
    public readonly eventTracker: EventTrackerService,
    private readonly indicator: IndicatorService,
    private readonly router: Router,
    private readonly tokenService: TokenService
  ) {
    super(router);
    this.device.hide();
    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe((event: NavigationStart) => {
        if (event.restoredState) this.clpService.isBackFromItem = true;
      });
  }

  public async ngOnInit() {
    this.checkSupportHtml();
    this.indicator.show();
    this.activatedRoute.paramMap.subscribe(() => {
      this.contentType = ProductTypeEnum[this.activatedRoute.snapshot.queryParamMap.get("contentType")];
      this.title = this.activatedRoute.snapshot.queryParamMap.get("title");
      this.identifier = +this.activatedRoute.snapshot.paramMap.get("id");
      this.getSubgenres(this.identifier);
      this.loadBook(this.identifier);
    });
  }

  public async getSubgenres(identifier) {
    const clientId = this.parametersService.clientId;
    this.cache.getObjectCache(`/api/genres/${identifier}/subgenres?clientId=${clientId}`)
      .subscribe((res) => {
        this.subgenres = res;
        this.showMore = (this.subgenres.length === 0);
      });
  }

  public async loadBook(identifier) {
    const clientId = this.parametersService.clientId;
    let Url = `/api/indexitem/${identifier}/landing?clientId=${clientId}&$inlinecount=allpages&$skip=0&$top=20`;
    await this.cache.getObjectCache(Url)
      .pipe(
        map((res) => {
          this.items = res.items;
          this.indicator.hide();
          this.indicator.hideHude();
          this.chkd.detectChanges();
          return res;
        })
      ).toPromise();
    if (this.clpService.isBackFromItem) super.scrollToPosition();
  }

  public goToPlpList(identifier, title) {
    this.trackerEvents({
      item_name: 'x_btn_show_all',
      x_item_content_type: this.contentType,
      x_source_id: this.identifier,
      x_source_name: this.title
    })
    this.indicator.show();
    if (ProductTypeEnum[this.contentType]) {
      this.router.navigate([`/clp/listItem/${identifier}`], {
        queryParams: { title: title, contentType: ProductTypeEnum[this.contentType] },
      });
    } else {
      this.router.navigate([`/clp/listItem/${identifier}`], {
        queryParams: { title },
      });
    }
  }

  public onSubgenres(identifier, title) {
    this.indicator.show();
    if (this.contentType) {
      if (this.contentType === ProductTypeEnum.AudioSeries || this.contentType === ProductTypeEnum.Podcast) {
        this.router.navigate([`/categories/listItem/${identifier}`], {
          queryParams: { title, contentType: ProductTypeEnum[this.contentType] },
        });
      } else {
        this.router.navigate(["/categories", identifier], {
          queryParams: { title, contentType: ProductTypeEnum[this.contentType] },
        });
      }
    } else {
      this.router.navigate(["/categories", identifier], {
        queryParams: { title },
      });
    }
    this.trackerEvents({
      item_name: 'x_btn_go_to_subgenre',
      x_item_content_type: ProductTypeEnum[this.contentType],
      x_item_id: title,
      x_item_name: identifier,
      x_source_id: this.identifier,
      x_source_name: this.title
    })
    this.title = title;
    this.showMore = false;
    this.getSubgenres(identifier);
    this.loadBook(identifier);
  }

  checkSupportHtml() {
    let supportVideo = this.checkHtml5Service.supports_video();
    let supportsCanvas = this.checkHtml5Service.supports_canvas();
    if (!supportVideo) {
      this.showOldVersion = true;
    }
    if (!supportsCanvas) {
      this.showOldVersion = true;
    }
  }

  public goToWeb() {
    this.trackerEvents({
      x_item_name: 'old_device_go_to_web'
    });
    this.device.goToWebWithToken();
  }

  public trackerEvents(item: object) {
    this.eventTracker.logEvent('x_plp_item_click', item);
  }
}
